import gql from 'graphql-tag'

export default config => {
  const { client } = config

  return {
    fetchAll: async payload => {
      const { start_date, end_date, tags, frequency = 'month' } = payload

      const query = gql`
        query (
          $tags: jsonb!
          $start_date: timestamp!
          $end_date: timestamp!
          $frequency: String
        ) {
          items: fn_tag_stats(
            args: {
              v_end_date: $end_date
              v_frequency: $frequency
              v_start_date: $start_date
              v_tags: $tags
            }
          ) {
            quantity
            revenue
            start_date
            tags
            label
          }
        }
      `

      const {
        data: { items }
      } = await client.query({
        query,
        variables: {
          start_date,
          end_date,
          frequency,
          tags
        }
      })

      return items
    }
  }
}
